module.exports = __webpack_public_path__ + "static/media/aplication-tracking.be6f551b.svg";